var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReplitLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#F4F4ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 49.25C53 43.037 58.037 38 64.25 38H116.75C122.963 38 128 43.037 128 49.25V98.0001H64.25C58.037 98.0001 53 92.9631 53 86.7501V49.25Z",
    fill: "#F26207"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.999 98.002H191.749C197.962 98.002 202.999 103.039 202.999 109.252V146.752C202.999 152.965 197.962 158.002 191.749 158.002H127.999V98.002Z",
    fill: "#F26207"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53 169.25C53 163.037 58.037 158 64.25 158H128V206.75C128 212.963 122.963 218 116.75 218H64.25C58.037 218 53 212.963 53 206.75V169.25Z",
    fill: "#F26207"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplitLight);
export default __webpack_public_path__ + "static/media/Replit-Light.5d8d19bb5c0bc9fe2ac8ba7366cb68cf.svg";
export { ForwardRef as ReactComponent };